import React, { useContext, useState, useEffect } from 'react'
import { useLocation, NavLink } from 'react-router-dom'
import { Capitalize } from '../utils/functions/tools/capitalizeString'

const SettingsNav = () => {
  //variables
  let [pageName, setPageName] = useState(null)

  //assigning location variable
  const location = useLocation();

  //destructuring pathname from location
  const { pathname } = location;

  //Javascript split method to get the name of the path in array
  const splitLocation = pathname.split("/");

  //active page name
  useEffect(() => {
    if (splitLocation[3] === "financial") {
      if (splitLocation[4] === "tax-rates") {
        setPageName(Capitalize("Tax Rates"))
      } else if (splitLocation[4] === "ticket-statuses") {
        setPageName(Capitalize("Ticket Statuses"))
      } else if (splitLocation[4] === "gateways") {
        setPageName(Capitalize("Payment Gateways"))
      } else {
        setPageName(Capitalize(splitLocation[4]))
      }
    } else if (splitLocation[3] === "company") {
      setPageName(Capitalize("Company Information"))
    } else {
      setPageName(Capitalize(splitLocation[3]))
    }
  })

  return (
    <div className='col-lg-3'>
      <div className="d-none d-lg-block dropdown">
        <ul className="nav nav-pills nav-vertical">
          <li className="nav-item">
            <NavLink to="/system/settings/general" className={splitLocation[1] === "general" ? "nav-link active" : "nav-link"}>
              General
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/system/settings/company" className={splitLocation[1] === "company" ? "nav-link active" : "nav-link"}>
              Company Information
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/system/settings/email" className={splitLocation[1] === "email" ? "nav-link active" : "nav-link"}>
              Email (SMTP)
            </NavLink>
          </li>
          <li className="nav-item">
            <a href="#menu-financial" className="nav-link" data-bs-toggle="collapse" aria-expanded={splitLocation[3] === "financial" ? "true" : "false"}>
              Financial
              <span className="nav-link-toggle"></span>
            </a>
            <ul className={splitLocation[3] === "financial" ? "nav nav-pills collapse show" : "nav nav-pills collapse"} id="menu-financial">
              <li className="nav-item">
                <NavLink to="/system/settings/financial/tax-rates" className={splitLocation[4] === "tax-rates" ? "nav-link active" : "nav-link"}>
                  Tax Rates
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/system/settings/financial/currencies" className={splitLocation[4] === "currencies" ? "nav-link active" : "nav-link"}>
                  Currencies
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/system/settings/financial/gateways" className={splitLocation[4] === "gateways" ? "nav-link active" : "nav-link"}>
                  Payment Gateways
                </NavLink>
              </li>
            </ul>
          </li>
          <li className="nav-item">
            <a href="#menu-reference-data" className="nav-link" data-bs-toggle="collapse" aria-expanded={splitLocation[3] === "reference-data" ? "true" : "false"}>
              Reference Data
              <span className="nav-link-toggle"></span>
            </a>
            <ul className={splitLocation[3] === "reference-data" ? "nav nav-pills collapse show" : "nav nav-pills collapse"} id="menu-reference-data">
              <li className="nav-item">
                <a href="#menu-geographical" className="nav-link" data-bs-toggle="collapse" aria-expanded={splitLocation[4] === "geographical" ? "true" : "false"}>
                  Geographical
                  <span className="nav-link-toggle"></span>
                </a>
                <ul className={splitLocation[4] === "geographical" ? "nav nav-pills collapse show" : "nav nav-pills collapse"} id="menu-geographical">
                  <li className="nav-item">
                    <NavLink to="/system/settings/reference-data/geographical/countries" className={splitLocation[5] === "countries" ? "nav-link active" : "nav-link"}>
                      Countries
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink to="/system/settings/reference-data/geographical/provinces" className={splitLocation[5] === "provinces" ? "nav-link active" : "nav-link"}>
                      Provinces
                    </NavLink>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
          <li className="nav-item">
            <a href="#menu-support" className="nav-link" data-bs-toggle="collapse" aria-expanded={splitLocation[3] === "support" ? "true" : "false"}>
              Support
              <span className="nav-link-toggle"></span>
            </a>
            <ul className={splitLocation[3] === "support" ? "nav nav-pills collapse show" : "nav nav-pills collapse"} id="menu-support">
              <li className="nav-item">
                <NavLink to="/system/settings/support/departments" className={splitLocation[4] === "departments" ? "nav-link active" : "nav-link"}>
                  Departments
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/system/settings/support/ticket-statuses" className={splitLocation[4] === "ticket-statuses" ? "nav-link active" : "nav-link"}>
                  Ticket Statuses
                </NavLink>
              </li>
            </ul>
          </li>
          <li className="nav-item">
            <a href="#menu-users" className="nav-link" data-bs-toggle="collapse" aria-expanded={splitLocation[3] === "user-management" ? "true" : "false"}>
              User Management
              <span className="nav-link-toggle"></span>
            </a>
            <ul className={splitLocation[3] === "user-management" ? "nav nav-pills collapse show" : "nav nav-pills collapse"} id="menu-users">
              <li className="nav-item">
                <NavLink to="/system/settings/user-management/staff" className={splitLocation[4] === "staff" ? "nav-link active" : "nav-link"}>
                  Staff
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/system/settings/user-management/roles" className={splitLocation[4] === "roles" ? "nav-link active" : "nav-link"}>
                  Roles
                </NavLink>
              </li>
            </ul>
          </li>
          <li className="nav-item">
            <NavLink to="/system/settings/changelog" className={splitLocation[1] === "changelog" ? "nav-link active" : "nav-link"}>
              Changelog
              <span className="badge bg-blue-lt ms-auto">v0.0.1-alpha</span>
            </NavLink>
          </li>
        </ul>
      </div>
      <div className="d-sidenav">
        <div className={splitLocation[2] === "settings" ? "nav-item dropdown active mb-2" : "nav-item dropdown mb-2"}>
          <a className="form-select" data-bs-toggle="dropdown" data-bs-auto-close="outside" role="button" aria-expanded="false" >
            <span className="">
              {pageName}
            </span>
          </a>
          <div className="dropdown-menu w-full">
            <NavLink className={splitLocation[3] === "general" ? "dropdown-item active" : "dropdown-item"} to="/system/settings/general" >
              General
            </NavLink>
            <NavLink className={splitLocation[3] === "company" ? "dropdown-item active" : "dropdown-item"} to="/system/settings/company" >
              Company Information
            </NavLink>
            <NavLink className={splitLocation[3] === "email" ? "dropdown-item active" : "dropdown-item"} to="/system/settings/email" >
              Email
            </NavLink>
            <NavLink className={splitLocation[4] === "tax-rates" ? "dropdown-item active" : "dropdown-item"} to="/system/settings/financial/tax-rates" >
              Tax Rates
            </NavLink>
            <NavLink className={splitLocation[4] === "currencies" ? "dropdown-item active" : "dropdown-item"} to="/system/settings/financial/currencies" >
              Currencies
            </NavLink>
            <NavLink className={splitLocation[4] === "gateways" ? "dropdown-item active" : "dropdown-item"} to="/system/settings/financial/gateways" >
              Payment Gateways
            </NavLink>
            <NavLink className={splitLocation[4] === "departments" ? "dropdown-item active" : "dropdown-item"} to="/system/settings/support/departments" >
              Departments
            </NavLink>
            <NavLink className={splitLocation[4] === "ticket-statuses" ? "dropdown-item active" : "dropdown-item"} to="/system/settings/support/ticket-statuses" >
              Ticket Statuses
            </NavLink>
            <NavLink className={splitLocation[4] === "departments" ? "dropdown-item active" : "dropdown-item"} to="/system/settings/user-management/staff" >
              Staff
            </NavLink>
            <NavLink className={splitLocation[4] === "departments" ? "dropdown-item active" : "dropdown-item"} to="/system/settings/user-management/roles" >
              Roles
            </NavLink>
            <NavLink className={splitLocation[3] === "changelog" ? "dropdown-item active" : "dropdown-item"} to="/system/settings/changelog" >
              Changelog
              <span className="badge bg-blue-lt ms-auto">v0.0.1-alpha</span>
            </NavLink>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SettingsNav